import { useEffect, useRef } from "react";

/** True only until `loading` has been false at least once (blocks full-page spinners on refetch). */
export default function useBlockingPageLoad(loading) {
  const hasLoaded = useRef(false);

  useEffect(() => {
    if (!loading) {
      hasLoaded.current = true;
    }
  }, [loading]);

  return loading && !hasLoaded.current;
}
